import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';

const isFromSearchEngine = () => {
  const siteList = /google.com|bing.com|yahoo.com|duckduckgo.com|aol.com/i;
  return typeof window !== 'undefined' && window?.document && siteList.test(window.document.referrer);
};

const getUrlSearchParams = (param, queryString) => {
  const searchParam = new RegExp('[?&]' + param + '=([^&#]*)').exec(queryString);
  return searchParam && decodeURI(searchParam[1]);
};
const isFromProductListAd = () => {
  const url = typeof window !== 'undefined' && window.location?.href;
  return /^Shopping/.test(getUrlSearchParams('cm_mmc', url));
};

const isFromPinterest = () => {
  const url = typeof window !== 'undefined' && window.location?.href;
  return /PIN_Shopping/.test(getUrlSearchParams('cm_mmc', url));
};

export const shouldDisplayReferrerRecommendations = () => {
  return isFromSearchEngine() || isFromProductListAd() || isFromPinterest();
};

export const shouldDisplayPipInStock = (data = {}) => {
  const { product = {} } = data || {};
  if (shouldDisplayReferrerRecommendations()) return false;
  if (podFulFillmentUtils.isDiscontinued(product)) return true;
  if (product?.availabilityType?.type === 'Browse Only') return podFulFillmentUtils.isOutOfStockYourStore(product);
  if (product?.availabilityType?.type === 'Online') return podFulFillmentUtils.isOutOfStockOnline(product);
  if (product?.availabilityType?.type === 'Shared') {
    return !!(podFulFillmentUtils.isOutOfStockYourStore(product)
    || podFulFillmentUtils.isOutOfStockOnline(product)
    || podFulFillmentUtils.isOutOfStockShared(product)
    || podFulFillmentUtils.isLimitedStock(product)
    || podFulFillmentUtils.isBackordered(product));
  }
  return false;
};

export const shouldDisplayPipAlternativeRecs = (data = {}) => {
  return !shouldDisplayReferrerRecommendations() && !shouldDisplayPipInStock(data);
};

export const shouldDisplayVisuallySimilar = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.visualNavigation;
};

export const shouldDisplayPipCollections = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.pipCollections;
};

export const shouldDisplaySupplementalRecs = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.ACC;
};

export const shouldDisplayRecsFBT = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.frequentlyBoughtTogether;
};

export const shouldDisplayFbtbundle = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.bundles;
};

export const shouldDisplayConfigurator = (data = {}, isServer) => {
  return !isServer && data?.product?.identifiers?.productType === 'CONFIGURABLE_BLINDS';
};

export const getAnchorSku = (data = {}, itemId) => {
  return data?.product?.info?.gccExperienceOmsId || itemId;
};

export const validatePipFlip = (data = {}, flag) => {
  return !flag && data?.product?.info?.gccExperienceOmsId;
};

export const flipPip = (
  configuredProductLabel,
  productData,
  hasPipFlip,
  productId,
  setHasPipFlip,
  itemId,
  anchorSku,
  setItemId
) => {
  const product = {
    configuredProductLabel,
  };
  const stockProduct = {
    configuredProductLabel: productData?.product?.identifiers?.productLabel,
  };
  if (hasPipFlip) {
    LIFE_CYCLE_EVENT_BUS.trigger('configurator.configurator_choice_selected_event', { product: stockProduct });
    LIFE_CYCLE_EVENT_BUS.trigger('configurator.configurator_sticky_nav_event', { product: stockProduct });
    LIFE_CYCLE_EVENT_BUS.trigger('configurator.configurator_media_gallery_event', { extMedia: {} });
    LIFE_CYCLE_EVENT_BUS.trigger('configurator.stock_product_chosen_event', { configuredItemId: productId });
  } else if (!hasPipFlip) {
    LIFE_CYCLE_EVENT_BUS.trigger('configurator.configurator_choice_selected_event', product);
    LIFE_CYCLE_EVENT_BUS.trigger('configurator.configurator_sticky_nav_event', product);
  }
  setHasPipFlip(!hasPipFlip);
  return itemId === anchorSku ? setItemId(productId) : setItemId(anchorSku);
};
